<div class="cy-wrapper">
  <div id="cy-preview" class="cy-container"></div>
  <div class="cy-label">
    <svg 
        width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="12" height="12" rx="6" fill="#FFAA00"/>
    </svg>
    {{ "SCHEMATIC_DIAGRAM.NOT_PUBLISHED" | translate }}
  </div>
  <button class="cy-btn">{{ "SCHEMATIC_DIAGRAM.PUBLISH" | translate }}</button>
</div>
